import { render, staticRenderFns } from "./shipment.vue?vue&type=template&id=18b35f66&scoped=true"
import script from "./shipment.vue?vue&type=script&lang=ts"
export * from "./shipment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b35f66",
  null
  
)

export default component.exports